import gql from 'graphql-tag';

const albumFolderFunnelData = gql`
  fragment albumFolderFunnelData on AlbumFolder {
    id
    name
    join_code
    album_type
    album_subtype
    album_price_mode
    price {
      value
      currency
    }
    pre_paid: is_demo
    join_type
    join_without_purchase
    force_join_without_purchase
    requires_album_folder_onboarding
    day_pricings_enabled
    limited_time_offer_active
  }
`;

export default albumFolderFunnelData;
